// Content for the Médailles Animaux "La solution" section. Interface values are illustrative.
export type Bi = { fr: string; en: string }

export const SOLUTION_IMAGES = {
  scene: 'https://cdn.magicpatterns.com/patterns/generated-images/6d5075e2-eb4c-4476-9d28-53fead49050e.jpg',
  milo: 'https://cdn.magicpatterns.com/patterns/generated-images/959ea251-4e11-460d-a096-8bb119f05470.jpg',
  luna: 'https://cdn.magicpatterns.com/patterns/generated-images/08dbce60-82bb-44c0-8e79-9fe418644ff3.jpg',
  bella: 'https://cdn.magicpatterns.com/patterns/generated-images/caf3f365-0d58-4b8f-812d-a0af34fc9ccd.jpg',
  simba: 'https://cdn.magicpatterns.com/patterns/generated-images/1283007d-6046-44ac-a35f-f74bb4ee0c1a.jpg',
}

export const solutionCopy = {
  eyebrow: { fr: 'La solution', en: 'The solution' },
  line1: { fr: 'Une expérience', en: 'One simple,' },
  line2: { fr: 'simple, complète', en: 'complete and' },
  line3: { fr: 'et automatisée.', en: 'automated experience.' },
  bodyBefore: { fr: 'Avec BCITI | ATNA', en: 'With BCITI | ATNA' },
  bodyAfter: {
    fr: ', les citoyens peuvent enregistrer leur animal, payer en ligne, recevoir des rappels et mettre à jour leurs informations — simplement, sur le web, l’application ou votre portail.',
    en: ', residents can register their pet, pay online, receive reminders and update their information — simply, on the web, in the app or on your portal.',
  },
  primary: { fr: 'Voir la solution en action', en: 'See the solution in action' },
  secondary: { fr: 'Parler à notre équipe', en: 'Talk to our team' },
  imageAlt: {
    fr: 'Une femme souriante tient son téléphone en serrant son golden retriever qui porte sa médaille',
    en: 'A smiling woman holds her phone while hugging her tagged golden retriever',
  },
  reminderTitle: { fr: 'Rappel automatique', en: 'Automatic reminder' },
  reminderBody: { fr: 'Le renouvellement de Milo arrive bientôt.', en: 'Milo’s renewal is coming up soon.' },
}

export const adminNav: { key: 'dashboard' | 'animals' | 'licences' | 'payments' | 'reminders' | 'reports' | 'analytics'; label: Bi }[] = [
  { key: 'dashboard', label: { fr: 'Tableau de bord', en: 'Dashboard' } },
  { key: 'animals', label: { fr: 'Animaux', en: 'Animals' } },
  { key: 'licences', label: { fr: 'Licences', en: 'Licences' } },
  { key: 'payments', label: { fr: 'Paiements', en: 'Payments' } },
  { key: 'reminders', label: { fr: 'Rappels', en: 'Reminders' } },
  { key: 'reports', label: { fr: 'Signalements', en: 'Incident reports' } },
  { key: 'analytics', label: { fr: 'Rapports', en: 'Reports' } },
]

export const adminCopy = {
  title: { fr: 'Animaux', en: 'Animals' },
  search: { fr: 'Rechercher un animal, un citoyen…', en: 'Search for a pet, a resident…' },
  active: { fr: 'Active', en: 'Active' },
  expiring: { fr: 'Expire bientôt', en: 'Expiring soon' },
}

export const animalRecords: { name: string; image: keyof typeof SOLUTION_IMAGES; kind: Bi; status: 'active' | 'expiring' }[] = [
  { name: 'Milo', image: 'milo', kind: { fr: 'Chien · golden retriever', en: 'Dog · Golden Retriever' }, status: 'active' },
  { name: 'Luna', image: 'luna', kind: { fr: 'Chat · domestique', en: 'Cat · Domestic' }, status: 'active' },
  { name: 'Bella', image: 'bella', kind: { fr: 'Chien · Labradoodle', en: 'Dog · Labradoodle' }, status: 'expiring' },
  { name: 'Simba', image: 'simba', kind: { fr: 'Chat · domestique', en: 'Cat · Domestic' }, status: 'active' },
]

export const solutionBenefits: { key: 'register' | 'payment' | 'reminders' | 'data'; title: Bi; body: Bi }[] = [
  { key: 'register', title: { fr: 'Enregistrement en ligne', en: 'Online registration' }, body: { fr: 'Processus simple et rapide pour les citoyens.', en: 'A simple, fast process for residents.' } },
  { key: 'payment', title: { fr: 'Paiement sécurisé', en: 'Secure payment' }, body: { fr: 'Paiement en ligne et renouvellements facilités.', en: 'Online payment and easier renewals.' } },
  { key: 'reminders', title: { fr: 'Rappels automatiques', en: 'Automatic reminders' }, body: { fr: 'Moins d’oublis, plus de renouvellements.', en: 'Fewer missed deadlines, more renewals.' } },
  { key: 'data', title: { fr: 'Données à jour', en: 'Current data' }, body: { fr: 'Registre complet pour une meilleure conformité et sécurité.', en: 'A complete registry for better compliance and safety.' } },
]
